import React from 'react';
import moment, { Moment } from 'moment';

import Week from './Week';
import { getMonthInfo } from './helpers';
import { MonthName, MonthWrapper } from './shared.styles';

interface IMonthCalendarProps {
  month: number;
  year: number;
  fromDate: Moment | undefined;
  toDate: Moment | undefined;
  startWeekDay: string;
  minDate: Moment;
  maxDate: Moment;
}

const MonthCalendar: React.FC<IMonthCalendarProps> = ({
  month,
  year,
  fromDate,
  toDate,
  startWeekDay,
  minDate,
  maxDate,
}) => {
  function generateWeek(): JSX.Element {
    const { totalWeek, totalDay } = getMonthInfo(year, month, startWeekDay);

    return totalWeek.map(
      (week: { days: number; start: number }, index: number): JSX.Element => (
        <Week
          key={index}
          week={week}
          month={month}
          year={year}
          isFirst={index === 0}
          fromDate={fromDate}
          toDate={toDate}
          totalDay={totalDay}
          minDate={minDate}
          maxDate={maxDate}
        />
      )
    );
  }

  return (
    <MonthWrapper data-month-index={month + 1}>
      <MonthName>
        {moment(`${year}-${month + 1}-1`, 'YYYY-MM-DD').format('MMMM YYYY')}
      </MonthName>
      <div>{generateWeek()}</div>
    </MonthWrapper>
  );
};

export default MonthCalendar;
